import React from "react";
import { Modal } from "@/components/ui";
import { fmt, fmtDate } from "@/lib/formatters";
import { Package, ClipboardList, Eye } from "lucide-react";
import { API_BASE_URL } from "@/services/api";

export const ViewMaterialExpenseModal = ({ isOpen, onClose, expense }) => {
  if (!expense) return null;

  const Card = ({ label, v, fullWidth = false }) => (
    <div className={`bg-slate-50 rounded-lg p-3 ${fullWidth ? 'col-span-2' : ''}`}>
      <div className="text-[10px] text-slate-500 mb-0.5 uppercase font-bold tracking-wider opacity-70">
        {label}
      </div>
      <div className="text-xs font-semibold text-brand-dark">
        {v !== undefined && v !== null && v !== "" ? String(v) : "—"}
      </div>
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Order Details: ${expense.sdId || expense.expenseId || "Unknown"}`} size="max-w-md">
      <div className="space-y-5">
        <div className="grid grid-cols-2 gap-3">
          <Card label="SD ID" v={expense.sdId} />
          <Card label="Customer Name" v={expense.clientName} />
          
          <div className="col-span-2 mt-2 pt-2 border-t border-slate-100">
            <label className="text-[11px] font-bold text-brand-blue uppercase tracking-wider block pl-1 mb-2 flex items-center gap-1.5">
              <ClipboardList size={14} /> Order Info
            </label>
          </div>

          <Card label="Date" v={expense.date ? fmtDate(expense.date) : "—"} />
          <Card label="Total Amount" v={`₹${fmt(expense.amount)}`} />
          <Card label="Status" v={expense.status ? expense.status.toUpperCase() : "—"} fullWidth />
        </div>
        {expense.estimationId && (
          <div className="flex justify-end mt-2 pt-4 border-t border-slate-100">
            <button
              onClick={() => window.open(`${API_BASE_URL}/api/estimations/${expense.estimationId}/stream-pdf`, '_blank')}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-[#C91D25] text-white rounded text-xs font-bold hover:bg-[#a8161d] transition-colors shadow-sm"
            >
              <Eye size={14} />
              View Quotation PDF
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};




